<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Pinia Stores
const componentsStore = useComponentsStore()

// Computed Properties
const listingName = computed(() => viewStore.listingName)
const tableName = computed(() => viewStore.tableName)
const showArchive = computed(() => viewStore.showArchive || false)

const text = computed(() => {
    return showArchive.value ? 'Close' : 'Open'
})

const componentId = computed(() => {
    return tableName.value ? componentsStore.componentIds[tableName.value] : undefined
})

const useArchive = computed(() => {
    if (!componentId.value) return false
    // Only display the Show Archive button if the archive is enabled for this component.
    let component = componentsStore.items.find(o => o.id === componentId.value)
    return !!(component && component.useArchive)
})

// Methods
const toggleArchive = () => {
    viewStore.setPage(1)
    viewStore.toggleShowArchive()
    viewStore.selectNone()
}
</script>

<template>
    <button
        v-if="useArchive" :class="{'warning': showArchive}" class="d-flex align-items-center" type="button"
        @click="toggleArchive"
    >
        <i class="me-2 bi-archive"/>
        {{ text }} archive
    </button>
</template>

<style scoped>
.warning {
    background: #ec971f;
    color: #fff;
    text-shadow: #253c8896;
}
</style>